/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Ref } from 'react';
import { ChipProps } from '../../../Chip';
import { TextFieldProps } from '../TextField';

export interface MultiChipFieldOnItemsChangeProps {
  /** True if all items in the chip are valid. */
  valid: boolean;
  /** All items in the input (valid and invalid). */
  items: Array<string>;
}

/**
 * The props for `<ChipList />`.
 */
export interface MultiChipFieldProps extends TextFieldProps {
  /**
   * The function to validate the chip input.
   */
  callback?(text: string): boolean;

  /**
   * A custom data-id identifier for the MultiChipField input.
   */
  dataId?: string;

  /**
   * Default list of chips.
   */
  defaultChips?: Array<ChipProps<string>>;

  /**
   * Reference to a hidden input with emails listed in a data-attribute.
   */
  emailsRef?: Ref<HTMLInputElement>;

  /**
   * Display floating text.
   */
  enableFloatingText?: boolean;

  /**
   * Handler for when the chips have changed (added OR removed).
   * @deprecated use "onItemsChange" instead.
   */
  onRemovableChipClick?: () => void;

  /**
   * Handler for when the chips have changed (added OR removed).
   */
  onItemsChange?: (props: MultiChipFieldOnItemsChangeProps) => void;

  /**
   * Placeholder text.
   */
  placeholder?: string;

  /**
   * Transformer to normalise the text of a chip item.
   */
  transformChipText?: (text: string) => string;
}

/**
 * The default prop values for `<MultiChipField />`.
 */
export const multiChipFieldPropsDefaults = {
  enableFloatingText: false,
  placeholder: ``,
};
